import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useAttachFile, useProjectAccess } from '@/hooks'
import { FILE_ATTACHMENTS_PERMISSION } from '../../../permissions/project/definitions'
import centerElement from '../../../utils/centerElement'
import { DropTarget } from './DropTarget'
import css from './FileDropZone.module.scss'
import { useFilesDrag } from './useFilesDrag'

interface Props extends React.PropsWithChildren {
  disabled?: boolean
}

const FileDropZone: React.FC<Props> = ({ disabled, children }) => {
  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)

  const { hasAccess } = useProjectAccess(
    FILE_ATTACHMENTS_PERMISSION.ATTACH_FILE
  )

  const isFeatureEnabled = canEdit && hasAccess

  const attachOffset = centerElement(0, 0, [])

  const { handleFile } = useAttachFile()
  const onDropped = (d: DataTransfer) => {
    const file = d.files.item(0)
    if (!file) {
      return
    }

    handleFile(file, attachOffset)
  }

  const { onDrop, active, onLeave, onEnter, onOver } = useFilesDrag(
    onDropped,
    !!disabled
  )

  if (!isFeatureEnabled) {
    return <>{children}</>
  }

  return (
    <div
      className={css.container}
      onDragEnter={onEnter}
      onDragLeave={onLeave}
      onDragOver={onOver}
      onDrop={onDrop}
    >
      {children}
      {active && !disabled && <DropTarget />}
    </div>
  )
}

export default FileDropZone
